import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SettingService } from './models/setting.service';

export const INSTALLATION_SETTING_NAME = 'installation';
export const WELCOME_WIZARD_PATH = '/bienvenue';

@Injectable({ providedIn: 'root' })
export class WelcomeWizardService {
  constructor(
    private settingService: SettingService,
    private router: Router
  ) {}

  /**
   * Vérifie si le paramètre "installation" est à 1.
   * Si oui, redirige vers la page du wizard de bienvenue.
   */
  checkInstallation(): void {
    this.settingService.all({ skipLoader: true }).subscribe({
      next: (res: any) => {
        const list = Array.isArray(res) ? res : (res?.data ?? []);
        this.settingService.setSettings(list);
        const installation = list.find((s: any) => s.name === INSTALLATION_SETTING_NAME);
        const isFirstRun = installation?.value === '1' || installation?.value === 1;
        const isWelcomePage = this.router.url.includes('/bienvenue');
        if (isFirstRun && !isWelcomePage) {
          this.router.navigate([WELCOME_WIZARD_PATH]);
        }
      },
      error: () => {}
    });
  }

  /**
   * Termine le wizard après store-init-settings : met à jour le cache et redirige (sans appel API).
   */
  finishFromStoreInit(): void {
    const installation = this.settingService.getSettingByName(INSTALLATION_SETTING_NAME);
    if (installation) {
      this.settingService.setSettingValue(INSTALLATION_SETTING_NAME, '0');
    }
  }

  /**
   * Termine le wizard : met à jour le paramètre installation à 0 et redirige vers le tableau de bord.
   */
  setInstallationDone(): void {
    const installation = this.settingService.getSettingByName(INSTALLATION_SETTING_NAME);
    if (!installation) {
      this.router.navigate(['/moni', 'dashboard']);
      return;
    }
    this.settingService.edit(installation.id, { value: '0' }).subscribe({
      next: () => {
        this.settingService.setSettingValue(INSTALLATION_SETTING_NAME, '0');
        this.router.navigate(['/moni', 'dashboard']);
      },
      error: () => {
        this.router.navigate(['/moni', 'dashboard']);
      }
    });
  }
}
